import Sortable from 'sortablejs';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-repository-nav', {
  mixins: [eventListenerMixin],

  properties: {
    url: {
      type: String,
    },
  },

  connected() {
    this.tree = this.querySelector('tr-tree');
    this.listenTo(this, 'tr-tree:sorted', this.handleSorted.bind(this));
    this.listenTo(this.tree, 'click', this.handleClick.bind(this));
    this.initRepositoriesSortable();
  },

  handleClick(e) {
    if (closest(e.target, '.link-toggle-item')) return;

    const item = closest(e.target, '.tr-tree-item-content');
    if (item) {
      Array.prototype.forEach.call(
        this.tree.querySelectorAll('.tr-tree-item-content.active'),
        element => element.classList.remove('active'),
      );
      item.classList.add('active');
    }
  },

  update(async = true) {
    if (async) {
      if (this.stack) this.stack.off('pageload');
      this.stack = window.tower.stack.one('pageload', () => this.updateNav());
    } else {
      this.updateNav();
    }
  },

  updateNav() {
    const tpl = document.querySelector('#tpl-tr-repository-nav');
    if (tpl) this.outerHTML = tpl.innerHTML;
  },

  initRepositoriesSortable() {
    this.sortable = new Sortable(this.querySelector('.tr-repository-tree > .tr-tree-list'), {
      group: 'tree-item',
      delay: 200,
      delayOnTouchOnly: true,
      animation: 0,
      filter: '.link-toggle-item',
      sort: true,
      swapThreshold: 0.25,
      emptyInsertThreshold: 8,
      draggable: '.repository-sortable-item',
      handle: '.nav-item',
      onEnd: this.updateRepositories.bind(this),
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
    });
  },

  updateRepositories(e) {
    const { item, to: targetList } = e;
    const list = Array.prototype.slice.call(
      targetList.querySelectorAll('.repository-sortable-item'),
    );
    window.$.ajax({
      url: `${item.dataset.sortUrl}?silent=true`,
      type: 'PATCH',
      data: {
        position: list.indexOf(item),
      },
    });
  },

  updateSortable() {
    this.tree.initSortable();
  },

  handleSorted(e) {
    const { item, targetList } = e.detail;
    const parent = closest(targetList, '.tr-tree-item');

    window.$.ajax({
      url: `${item.dataset.sortUrl}?silent=true`,
      type: 'post',
      dataType: 'script',
      data: {
        'tr_repository_movement[position]': Array.prototype.slice
          .call(targetList.children)
          .indexOf(item),
        'tr_repository_movement[parent_gid]': parent.dataset.gid,
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
